var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// require('bootstrap');

// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
require('bootstrap-datepicker');
// require('bootstrap-material-design');

// require('jquery.placeholder');
// require('jquery-sticky');
// require('jquery-match-height');
require('magnific-popup');

require('owl.carousel');


// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {


    $('#btn-menu').click(function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });


        function setAutoplay() {
            let windowWidth = $(window).innerWidth();
            let video = document.querySelector('#carousel-video');
            if(windowWidth > 992) {
                $('#carouselExampleFade').on('slide.bs.carousel', function(e) {
                    let slides = $(this).find('.carousel-item');
                    let vid = slides[e.to].querySelectorAll('video')[0];
                    if (vid) {
                        vid.autoplay = true;
                        vid.play(); // play video when carousel displays the video

                    }
                });
            } else {
                video.pause();
                video.autoplay = false;
            };
        }


    $(window).on('resize load', function() {
        initFlipbook();
        setVideoHeight();
        if ($('#carousel-video').length > 0) ({
            setAutoplay
        });

    });


   var bigimage = $("#big");
    var thumbs = $("#thumbs");
    //var totalslides = 10;
    var syncedSecondary = true;

    bigimage
        .owlCarousel({
            items: 1,
            nav: true,
            autoplay: false,
            margin:0,
            autoplaySpeed: 1000,
            dots: true,
            smartSpeed:1000,
            autoplaySpeed:1000,
            navSpeed:1000,
            autoplayHoverPause: true,
            dotsEach: 2,
            loop: true,
            margin: 0,
            responsiveRefreshRate: 200,
            navText: [

            ],
            responsive: {

                768: {
                    dots: false,
                },
            },
        })
        .on("changed.owl.carousel", syncPosition);

    thumbs
        .on("initialized.owl.carousel", function() {
            thumbs
                .find(".owl-item")
                .eq(0)
                .addClass("current");
        })
        .owlCarousel({
            items: 5,
            dots: false,
            autoplay: true,
            nav: false,
            margin: 7.5,
            // slideBy: 6,
            responsiveRefreshRate: 100
        })
        .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }
        //to this
        thumbs
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
            .find(".owl-item.active")
            .first()
            .index();
        var end = thumbs
            .find(".owl-item.active")
            .last()
            .index();

        if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            bigimage.data("owl.carousel").to(number, 100, true);
        }
    }

    thumbs.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
    });



    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    // Facebook click events
    // phone
    $('a[href^="tel:"]').on('click', function(e) {
        window.fbq('track', 'Contact');
    });
    // email
    $('a[href^="mailto:"]').on('click', function(e) {
        window.fbq('track', 'Contact');
    });


});

// window.recaptchaInit = function () {
//     $(".g-recaptcha").each(function() {
//         var el = $(this);
//         grecaptcha.render($(el).attr("id"), {});
//     });
//     window.dispatchEvent(new CustomEvent('recaptcha-init'));
// }

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}

function initFlipbook() {
    if ($('#flipbookContainer').length > 0) {

        let pdf = $('#flipbookContainer').data('src');
        let pdf_options = {
            webgl: true,
            height: "auto",
            backgroundColor: "#f3f1f0",
            enableDownload: false,
            scrollWheel: false,
            allControls: "pageNumber,zoomIn,zoomOut,fullScreen",
            moreControls: "",
            hideControls: "altPrev,altNext,share,thumbnail,sound,pageMode,startPage,endPage,more",
            soundEnable: false,
        };

        flipBook = $("#flipbookContainer").flipBook(pdf, pdf_options);

        $('#brochure-tab').on('shown.bs.tab', function(e) {
            // fix hidden tab init issue
            flipBook.resize();
        });
    }
}


    function setVideoHeight() {
        let windowWidth = $(window).innerWidth();
        let video = $('.carousel-item .carousel-video');

        if(windowWidth > 1700) {
            // Filter the elements if carousel-item is active
            var aspectRatio = 3.6; // Aspect ratio of 100:27.74

            // Calculate the height based on the aspect ratio
            var height = (windowWidth / aspectRatio).toFixed(2); // Round to 2 decimal places

            // Set the calculated height as inline style
            video.height(height);

            $('#carouselExampleFade').on('slide.bs.carousel', function() {
            let video = $('.carousel-item .carousel-video');
                if(video) {
                    video.height(height);
                }
            });
        }
    }